import React, { Component, createRef } from 'react';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import BlockUi from '@availity/block-ui';


import { cadenas } from '../../Utils/cadenas';
import { PATHS_API, ROLES, NUM_ROWS_POR_PAGINA, EDOS_COGNITO, MILLIS_RESET_DISABLED } from '../../Utils/constants';
import FormularioRegistro from '../../Components/FormularioRegistro';
import {APIGATEWAY} from '../../Api/ApiGateway';
import { UsuarioInterface } from '../../Interfaces/Usuario.interface';
import { Toast } from 'primereact/toast';
import { saveAs } from 'file-saver';
import { timestampDescarga } from '../../Utils/fechas';

/** Definición del estado para el componente. */
interface State {
  usuarios: Array<{}>;
  dialogVisible: boolean;
  id: string;
  nombreCompleto: string;
  correo: string;
  usuario: string;
  blocking: boolean;
  [key: string]: any;
  tituloDialog: string;
  labelBtnAccion: string;
  rolAdminSysAdminReadList: Array<{}>;
  rolAdminSysAdminReadSeleccionado: string|null;
  tiporolAdminSysAdminReadSeleccionado: string;
}

/**
 * @class
 * Componente de tipo clase para mostrar la pantalla donde se realiza
 * la administración de los usuarios de tipo ADMIN_SISTEMA.
 */
class AdministradorSistema extends Component<{}, State> {
  private dataTable: any;

  private toast: any;
  exportToCSV = (data: any[], columnas: string[], encabezados: Record<string, string>, filenamePrefix: string) => {
      if (!data || data.length === 0) return;
      const now = new Date();
      const timestamp = timestampDescarga(); // Ej: 2025-10-02T11-12-00-000Z
      const filename = `${filenamePrefix}_${timestamp}.csv`;

      const headers = columnas.map((col) => encabezados[col] || col);
      const rows = data.map((row) => columnas.map((field) => `"${row[field] ?? ''}"`).join(','));
      const csvContent = [headers.join(','), ...rows].join('\n');
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      saveAs(blob, filename);
  };
  constructor(props: any) {
    super(props);
    this.dataTable = createRef();
    this.state = {
      usuarios: [],
      dialogVisible: false,
      id: '',
      nombreCompleto: '',
      correo: '',
      usuario: '',
      blocking: false,
      tituloDialog: '',
      labelBtnAccion: '',
      rolAdminSysAdminReadList: [],
      rolAdminSysAdminReadSeleccionado: null,
      tiporolAdminSysAdminReadSeleccionado: '',
    };
    this.toast = createRef();
    this.export = this.export.bind(this);
    this.limpiarFormulario = this.limpiarFormulario.bind(this);
    this.validarRegistro = this.validarRegistro.bind(this);
    this.registrar = this.registrar.bind(this);
    this.eliminar = this.eliminar.bind(this);
    this.settearState = this.settearState.bind(this);
    this.obtenerAdministradoresSistema = this.obtenerAdministradoresSistema.bind(this);
    this.showDialogNuevo = this.showDialogNuevo.bind(this);
    this.activarDesactivar = this.activarDesactivar.bind(this);
    this.resetear = this.resetear.bind(this);
    this.setRolAdminSysAdminReadList = this.setRolAdminSysAdminReadList.bind(this);
  }

  /**
   * Limpiar las variables de estado.
   * */
  limpiarFormulario() {
    this.setState({
      id: '',
      nombreCompleto: '',
      correo: '',
      usuario: '',
      rol: '',
      rolAdminSysAdminReadSeleccionado: '',
    });
  }

  /**
   * Función para acceder al valor de los inputs
   * del componente FormularioRegistro.
   */
  settearState(id: string, value: any) {
    this.setState({ [id]: value });
  }

  /**
   * Se ejecuta antes de renderizar el componente.
   */
  componentDidMount=async()=> {
      let res = await APIGATEWAY.validar();
      if (res){
        this.setState({ blocking: true });
        this.obtenerAdministradoresSistema();
        this.setRolAdminSysAdminReadList();
      }
  }

  /**
   * Obtener los usuarios de tipo ADMIN_SISTEMA.
   */
  obtenerAdministradoresSistema() {
    const body = {
      usuario: '*',
    };
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/leer', body)
      .then((response) => {
        console.log('AdministradorSistema -> obtenerAdministradoresSistema -> response', response);
        const datosFormateados = response.map((dato: Partial<Record<string, any>>) => {
        if (dato && typeof dato === 'object' && 'activo' in dato) {
            return {
            ...dato,
            activoFormatted: dato ? cadenas.ACTIVO_SI : cadenas.ACTIVO_NO,
            };
        }
        return dato;
        });

        this.setState({
            usuarios: datosFormateados,
            blocking: false,
        });
      })
      .catch((error) => {
        console.log('AdministradorSistema -> obtenerAdministradoresSistema -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ADMINSIS_ERROR_OBTENER_USUARIOS);
      });
  }

  setRolAdminSysAdminReadList() {
    this.setState({
      rolAdminSysAdminReadList: [
        { value: ROLES.ADMINSIS, label: ROLES.ADMINSIS_GENERAL_LABEL },
        { value: ROLES.ADMINSIS_NSO, label: ROLES.ADMINSIS_NSO_LABEL },
        { value: ROLES.ADMINSIS_LOG, label: ROLES.ADMINSIS_LOGISTICA_LABEL },
        { value: ROLES.ADMINREAD, label: ROLES.ADMINREAD_LABEL },
        { value: ROLES.SEGUROS, label: ROLES.SEGUROS_LABEL },
        { value: ROLES.ADMINNSO, label: ROLES.ADMINNSO_LABEL },
      ],
    });
  }

  /**
   * Validar el registro del usuario.
   * @param {React.FormEvent} event Evento submit del formulario.
   */
  validarRegistro(event: React.FormEvent) {
    event.preventDefault();
    if (this.validarFormulario()) {
      if (this.state.rolAdminSysAdminReadSeleccionado != null) {
        var rol = this.state.rolAdminSysAdminReadSeleccionado;
        var tipoadmin = this.state.tiporolAdminSysAdminReadSeleccionado;
        if (
          this.state.rolAdminSysAdminReadSeleccionado.startsWith('ADMIN_SISTEMA') &&
          this.state.rolAdminSysAdminReadSeleccionado.length > 13
        ) {
          rol = this.state.rolAdminSysAdminReadSeleccionado.substring(0, 13);
          tipoadmin = this.state.rolAdminSysAdminReadSeleccionado.substring(
            14,
            this.state.rolAdminSysAdminReadSeleccionado.length
          );
        }
        let body: UsuarioInterface = {
          nombreCompleto: this.state.nombreCompleto,
          correo: this.state.correo,
          usuario: this.state.usuario,
          rol: rol,
          codigoEmpresa: '',
          tipoadmin: tipoadmin,
        };
        this.setState({ blocking: true });
        APIGATEWAY.post(PATHS_API.VALIDAR_USUARIO_SIGNUP, body)
          .then((usuarioValidado) => {
            console.log('AdministradorSistema -> validarRegistro -> usuarioValidado', usuarioValidado);
            this.registrar(usuarioValidado);
          })
          .catch((error) => {
            console.log('AdministradorSistema -> validarRegistro -> error', error);
            this.setState({ blocking: false });
            this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, error.response.data);
          });
      }
    }
  }
  validarFormulario() {
    var rol = this.state.rolAdminSysAdminReadSeleccionado;
    var nombre = this.state.nombreCompleto;
    var correo = this.state.correo;
    var resultado = true;
    if (rol === '' || rol === null) {
      this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, 'Debe capturar el rol del usuario');
      resultado = false;
    }
    if (nombre === '' || nombre === null) {
      this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, 'Debe capturar el nombre completo');
      resultado = false;
    }
    if (undefined === correo || correo === '' || correo === null || !this.validarCorreo()) {
      this.showNotificacion(
        cadenas.GROWL_ERROR,
        cadenas.ERROR_TITULO,
        'Debe capturar el correo electrónico correctamente'
      );
      resultado = false;
    }
    return resultado;
  }

  /**
   * Registro del usuario.
   * @param {any} body Información del usuario para registrar.
   */
  registrar(body: any) {
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/crear', body)
      .then(() => {
        this.limpiarFormulario();
        this.setState({
          blocking: false,
          dialogVisible: false,
        });
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.showNotificacion(
          cadenas.GROWL_SUCCESS,
          cadenas.EXITO_TITUTLO,
          cadenas.USUARIO_REGISTRADO + ' ' + body.correo
        );
        this.obtenerAdministradoresSistema();
      })
      .catch((error) => {
        this.limpiarFormulario();
        console.log('AdministradorSistema -> registrar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, error.response.data);
      });
  }

  /**
   * Eliminar el usuario.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  eliminar(rowData: any) {
    this.setState({ blocking: true });
    let body = {
      usuario: rowData.usuario,
    };
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/borrar', body)
      .then(() => {
        this.setState({
          blocking: false,
          dialogVisible: false,
        });
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.obtenerAdministradoresSistema();
      })
      .catch((error) => {
        console.log('AdministradorSistema -> eliminar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ADMINSIS_ERROR_ELIMINACION);
      });
  }

  /**
   * Activar y desactivar según sea el caso del usuario de acuerdo a su
   * propiedad activo.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  activarDesactivar(rowData: any) {
    const body = {
      usuario: rowData.usuario,
    };
    const path = rowData.activo ? PATHS_API.USUARIOS_API + '/desactivar' : PATHS_API.USUARIOS_API + '/activar';
    APIGATEWAY.post(path, body)
      .then((response) => {
        console.log('AdministradorSistema -> activarDesactivar -> response', response);
        this.obtenerAdministradoresSistema();
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
      })
      .catch((error) => {
        console.log('AdministradorSistema -> activarDesactivar -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ACCION_NO_EXITOSA);
      });
  }

  /**
   * Resetear la contraseña del usuario.
   * @param {any} rowData Instancia del row que pertenece al datatable.
   */
  resetear(rowData: any) {
    const body = {
      usuario: rowData.usuario,
    };
    APIGATEWAY.post(PATHS_API.USUARIOS_API + '/reset', body)
      .then((response) => {
        console.log('AdministradorSistema -> resetear -> response', response);
        this.obtenerAdministradoresSistema();
        this.showNotificacion(cadenas.GROWL_SUCCESS, cadenas.EXITO_TITUTLO, cadenas.ACCION_EXITOSA);
        this.showNotificacion(
          cadenas.GROWL_SUCCESS,
          cadenas.EXITO_TITUTLO,
          cadenas.USUARIO_RESET + ' ' + rowData.correo
        );
      })
      .catch((error) => {
        console.log('AdministradorSistema -> resetear -> error', error);
        this.setState({ blocking: false });
        this.showNotificacion(cadenas.GROWL_ERROR, cadenas.ERROR_TITULO, cadenas.ACCION_NO_EXITOSA);
      });
  }

  /**
   * Mostrar la notificación de tipo Growl (componente del framewrok Prime React).
   * @param {string} type Tipo de la notificación.
   * @param {string} title Título de la notificación.
   * @param {string} message Mensaje de la notificación.
   */
  showNotificacion(type: string, title: string, message: string) {
    this.toast.current?.show({
      severity: type,
      summary: title,
      detail: message,
    });
  }

  /**
   * Exportar los datos del datatable a formato CSV.
   * @param {any} dataTable Referencia del datatable.
   */
  export() {
    const data = this.dataTable.current.props.value;
    if (data.every((u: any) => 'nombreCompleto' in u)) {
      const columnasExportadas = ['nombreCompleto', 'usuario', 'correo','rol','codigoEmpresa','estado','activoFormatted'];
      const encabezadosPersonalizados = {
        nombreCompleto: cadenas.ADMINSIS_DATA_NOMBRE_COMPLETO,
        usuario: cadenas.ADMINSIS_DATA_USUARIO,
        correo: cadenas.ADMINSIS_DATA_CORREO,
        rol: cadenas.ADMINSIS_DATA_ROL,
        codigoEmpresa: cadenas.ADMINSIS_DATA_COD_EMPRESA,
        estado: cadenas.ADMINSIS_DATA_ESTADO,
        activoFormatted: cadenas.ADMINSIS_DATA_ACTIVO,
      };
      this.exportToCSV(data, columnasExportadas, encabezadosPersonalizados, 'AdminSis');
    } else {
      this.dataTable.current.exportCSV();
    }
  }

  /**
   * Desactivar o activar boton de reset para cada usuario
   */
  activarReset(rowData: any) {
    let activar = true;
    if (rowData.activo) {
      if (rowData.estado === EDOS_COGNITO.RESET) {
        var diff = new Date().getTime() - rowData.fechaUltimoReset;
        if (diff > MILLIS_RESET_DISABLED) {
          activar = false;
        }
      } else if (rowData.estado !== EDOS_COGNITO.CREADO) {
        activar = false;
      }
    }
    return activar;
  }

  /**
   * Mostrar el dialog para registrar usuario.
   */
  showDialogNuevo() {
    this.limpiarFormulario();
    this.setState({
      dialogVisible: true,
      tituloDialog: cadenas.ADMINSIS_DIALOG_NUEVO_TITULO,
      labelBtnAccion: cadenas.BTN_GUARDAR,
    });
  }
  validarCorreo() {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(this.state.correo);
  }
  /**
   * @function
   * Función principal para renderizar el contenido del componente.
   */
  render() {
    const headerDatatable = (
      <div className="p-grid">
        <div className="p-col-6" style={{ textAlign: 'left' }}>
          <Button
            className="p-button p-button-rounded"
            label={cadenas.ADMINSIS_BTN_NUEVO}
            onClick={this.showDialogNuevo}
          />
        </div>
        <div className="p-col-6" style={{ textAlign: 'right' }}>
          <Button
            type="button"
            icon="pi pi-external-link"
            iconPos="left"
            label={cadenas.BTN_EXPORTAR_CSV}
            onClick={this.export}
          />
        </div>
      </div>
    );
    const headerCard = (
      <div style={{ textAlign: 'center' }}>
        <h1>{cadenas.ADMINSIS_VISTA_TITULO}</h1>
      </div>
    );
    const footerDialog = (
      <div>
        <Button
          formNoValidate
          className="p-button p-button-success"
          label={this.state.labelBtnAccion}
          icon="pi pi-check"
          type="submit"
        />
        <Button
          type="button"
          className="p-button p-button-danger"
          label={cadenas.BTN_CANCELAR}
          icon="pi pi-times"
          onClick={(e) => {
            this.limpiarFormulario();
            this.setState({ dialogVisible: false });
          }}
        />
      </div>
    );
    const actionDatatable = (rowData: any, column: any) => {
      return (
        <div>
          <Button
            tooltip={rowData.activo ? cadenas.ADMINSIS_BTN_DESACTIVAR : cadenas.ADMINSIS_BTN_ACTIVAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            disabled={rowData.estado === EDOS_COGNITO.RESET || rowData.estado === EDOS_COGNITO.CREADO}
            icon={rowData.activo ? 'pi pi-user-minus' : 'pi pi-user-plus'}
            className={rowData.activo ? 'p-button-danger' : 'p-button-success'}
            style={{ marginRight: '.5em' }}
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.activarDesactivar(rowData);
              }
            }}
          />
          <Button
            tooltip={cadenas.ADMINSIS_BTN_RESET}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-key"
            className="p-button-success"
            style={{ marginRight: '.5em' }}
            disabled={this.activarReset(rowData)}
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.resetear(rowData);
              }
            }}
          />
          <Button
            tooltip={cadenas.BTN_ELIMINAR}
            tooltipOptions={{ position: 'top' }}
            type="button"
            icon="pi pi-trash"
            className="p-button-warning"
            onClick={(e) => {
              if (window.confirm(cadenas.CONFIRMAR_ACCION)) {
                this.eliminar(rowData);
              }
            }}
          />
        </div>
      );
    };
    return (
      <div>
        <BlockUi message="Cargando.." tag="div" blocking={this.state.blocking}>
          <Toast ref={this.toast} />
          <div className="p-grid">
            <div className="p-col-12">
              <Card header={headerCard} style={{ padding: '1em' }}>
                <div className="p-grid">
                  <div className="p-col-12">
                    <DataTable
                      filterDisplay="row"
                      value={this.state.usuarios}
                      paginator={true}
                      rows={NUM_ROWS_POR_PAGINA}
                      header={headerDatatable}
                      responsiveLayout="scroll"
                      ref={this.dataTable}
                      emptyMessage={cadenas.DATATABLE_VACIO}
                    >
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="nombreCompleto"
                        header={cadenas.ADMINSIS_DATA_NOMBRE_COMPLETO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="usuario"
                        header={cadenas.ADMINSIS_DATA_USUARIO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="correo"
                        header={cadenas.ADMINSIS_DATA_CORREO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="rol"
                        header={cadenas.ADMINSIS_DATA_ROL}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="codigoEmpresa"
                        header={cadenas.ADMINSIS_DATA_COD_EMPRESA}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="estado"
                        header={cadenas.ADMINSIS_DATA_ESTADO}
                        filter={true}
                        sortable={true}
                      />
                      <Column
                        showFilterMenu={false}
                        filterMatchMode="contains"
                        field="activoFormatted"
                        header={cadenas.ADMINSIS_DATA_ACTIVO}
                        style={{ width: '5em' }}
                      />
                      <Column body={actionDatatable} style={{ textAlign: 'center', width: '10em' }} />
                    </DataTable>
                  </div>
                </div>
              </Card>
            </div>

            <form onSubmit={this.validarRegistro}>
              <Dialog
                appendTo={document.body.querySelector('form')}
                header={this.state.tituloDialog}
                visible={this.state.dialogVisible}
                position="center"
                blockScroll={true}
                footer={footerDialog}
                style={{ width: '50vw' }}
                modal={true}
                onHide={() => {
                  this.limpiarFormulario();
                  this.setState({ dialogVisible: false });
                }}
              >
                <FormularioRegistro settearState={this.settearState} stateParent={this.state} />
              </Dialog>
            </form>
          </div>
        </BlockUi>
      </div>
    );
  }
}

export default AdministradorSistema;
